/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/video_medium'
export default icon
